import { put, takeLatest } from 'redux-saga/effects';

import { requestRegionList } from '../../../services/Region';
import { fetchRegionListFailure, fetchRegionListRequest, fetchRegionListSuccess } from '../../reducers/region';

export function* watchRegionSaga() {
  yield takeLatest(fetchRegionListRequest, fetchRegionList);
}

/**
 *
 * @param {*} param0
 */
function* fetchRegionList({ payload }) {
  try {
    const response = yield requestRegionList(payload);
    yield put(fetchRegionListSuccess(response));
  } catch (error) {
    yield put(fetchRegionListFailure('Failed to get list of Region'));
  }
}
